import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center px-4 lg:px-8 pt-2 pb-1 h-12 border-b border-primary-100 whitespace-nowrap overflow-x-scroll overflow-y-hidden" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 個人データ ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 学習履歴 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" バッジ一覧 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 提出物 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" TODO(試験運用中) ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 記録(試験運用中) ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      _createVNode(_component_router_link, {
        to: "profile",
        class: ["py-2 px-4 font-medium text-sm border-black cursor-pointer transition-colors duration-300 hover:bg-gray-100", {
          'text-gray-500': !_ctx.isProfilePage,
          'border-b-2': _ctx.isProfilePage
        }]
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["class"]),
      (!_ctx.isExclusiveSchoolAiUser)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "history",
            class: ["py-2 px-4 font-medium text-sm border-black cursor-pointer transition-colors duration-300 hover:bg-gray-100", {
          'text-gray-500': !_ctx.isHistoryPage,
          'border-b-2': _ctx.isHistoryPage
        }]
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      (!_ctx.isExclusiveSchoolAiUser)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: "badge",
            class: ["py-2 px-4 font-medium text-sm border-black cursor-pointer transition-colors duration-300 hover:bg-gray-100", { 'text-gray-500': !_ctx.isBadgePage, 'border-b-2': _ctx.isBadgePage }]
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      (!_ctx.isExclusiveSchoolAiUser)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: "submissions",
            class: ["py-2 px-4 font-medium text-sm border-black cursor-pointer transition-colors duration-300 hover:bg-gray-100", {
          'text-gray-500': !_ctx.isSubmissionsPage,
          'border-b-2': _ctx.isSubmissionsPage
        }]
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        to: "todo",
        class: ["py-2 px-4 font-medium text-sm border-black cursor-pointer transition-colors duration-300 hover:bg-gray-100", {
          'text-gray-500': !_ctx.isTodoPage,
          'border-b-2': _ctx.isTodoPage
        }]
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["class"]),
      (_ctx.canUseLearningCard)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 3,
            to: "reflection",
            class: ["py-2 px-4 font-medium text-sm border-black cursor-pointer transition-colors duration-300 hover:bg-gray-100", {
          'text-gray-500': !_ctx.isReflectionPage,
          'border-b-2': _ctx.isReflectionPage
        }]
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true)
    ])
  ]))
}